import React, { Component } from "react";
import PropTypes from "prop-types";
import { apiUrl } from "../config/apiUrl";
import Loading from "../../lib/steps_components/common/Loading";
import { getSessionId } from "../utils/sessionmanagement";

class SfxConfirmDetailComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileNo: this.props.mobileNo,
      location: this.props.location,
      city: this.props.city,
      locationError: null,
      cityError: null,
      mobileNumberError: null,
      confirmButtonClicked: false,
    };
  }

  checkInputValidation = () => {
    if (!this.state.location) {
      this.setState({ firstNameError: "Please Enter Location" });
      return false;
    }
    if (!this.state.city) {
      this.setState({ cityError: "Please Enter City" });
      return false;
    }
    return true;
  };
  onConfirmButtonClick = () => {
    if (this.checkInputValidation() && !this.state.confirmButtonClicked) {
      this.setState({ confirmButtonClicked: true });
      let url = `${apiUrl}candidate-response/`;
      let body = {
        session_id: getSessionId(),
        chat_identifier: this.props.chatFormIdentifier,
        identifier: this.props.identifier,
        identifier_type: this.props.identifierType,
        type: this.props.type,
        refer_candidate_api: true,
        response: {
          candidate_name: this.props.candidateName,
          mobile_no: this.state.mobileNo,
          city: this.state.city,
          location: this.state.location,
        },
      };
      fetch(url, {
        method: "post",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((dataReceived) => {
          this.props.triggerNextStep();
        });
    }
  };

  render() {
    return (
      <div>
        <div>
          {" "}
          {this.props.chatFormIdentifier === "sfx_delhi"
            ? "Neeche apni details check karen jiska use aapke Shadowfax mai khata banane ke liye kiya jayega/नीचे अपना डिटेल्स जांचें जिसका उपयोग आपका शैडोफैक्स खाता बनाने के लिए किया जाएगा"
            : "Check Your Details below which will be used to create your Shadowfax Account"}
        </div>
        <div>
          <br />
        </div>
        <div>
          <div style={{ textAlign: "left", marginBottom: "2px" }}>
            <label htmlFor='mobileNo'>Mobile No</label>
          </div>
          <div style={{ textAlign: "left" }}>
            <input
              id={"mobileNo"}
              type='text'
              disabled={true}
              value={this.state.mobileNo}
              onChange={(e) => {
                const mobileNumber = e.target.value;
                this.setState({ mobileNo: mobileNumber });
                this.setState({ mobileNumberError: null });
              }}
              style={{
                marginBottom: "10px",
                background: "white",
                color: "black",
                maxWidth: "100%",
                borderRadius: "5px",
                padding: "2px 4px",
              }}
            />
          </div>
          {this.state.mobileNumberError ? (
            <div style={{ color: "red" }}>{this.state.mobileNumberError}</div>
          ) : null}

          <div style={{ textAlign: "left", marginBottom: "2px" }}>
            <label htmlFor='location'>Location</label>
          </div>
          <div style={{ textAlign: "left" }}>
            <input
              id={"location"}
              type='text'
              autoFocus
              value={this.state.location}
              onChange={(e) => {
                this.setState({ location: e.target.value });
                if (!e.target.value.trim()) {
                  this.setState({ locationError: "Please Enter Location" });
                } else {
                  this.setState({ locationError: null });
                }
              }}
              style={{
                marginBottom: "10px",
                background: "white",
                color: "black",
                maxWidth: "100%",
                borderRadius: "5px",
                padding: "2px 4px",
              }}
            />
          </div>
          {this.state.locationError ? (
            <div style={{ color: "red" }}>{this.state.locationError}</div>
          ) : null}

          <div style={{ textAlign: "left", marginBottom: "2px" }}>
            <label htmlFor='city'>City</label>
          </div>
          <div style={{ textAlign: "left" }}>
            <input
              id={"city"}
              type='text'
              value={this.state.city}
              onChange={(e) => {
                this.setState({ city: e.target.value });
              }}
              style={{
                marginBottom: "10px",
                background: "white",
                color: "black",
                maxWidth: "100%",
                borderRadius: "5px",
                padding: "2px 4px",
              }}
            />
          </div>
          {this.state.cityError ? (
            <div style={{ color: "red" }}>{this.state.cityError}</div>
          ) : null}

          <div>
            <br />
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: "5px",
              padding: "5px 7px",
              color: "#111",
              fontWeight: "700",
              boxShadow:
                "0px 2px 11px rgb(0 0 0 / 30%), 0px 2px 6px rgb(0 0 0 / 15%",
              width: "60%",
              margin: "5px auto",
            }}
            onClick={this.onConfirmButtonClick}
          >
            Confirm
          </div>
        </div>
        {this.state.loading && this.state.uploadClicked ? <Loading /> : null}
      </div>
    );
  }
}

SfxConfirmDetailComponent.propTypes = {
  steps: PropTypes.object,
};

SfxConfirmDetailComponent.defaultProps = {
  steps: undefined,
};

export default SfxConfirmDetailComponent;
